import { HTTP_SCHEME_REGEX } from '@/constants/regex';

/**
 * Prefixes `https://` on a scheme-less URL so an `href` opens it as an external
 * site instead of resolving it against the current page. ENG-3662.
 */
export const ensureProtocol = (url?: string | null): string | undefined => {
  const value = typeof url === 'string' ? url.trim() : '';
  if (!value) return undefined;

  return HTTP_SCHEME_REGEX.test(value) ? value : `https://${value}`;
};
